import { Suspense, useEffect } from 'react';

import { Switch, Route } from 'react-router-dom';

import { DocumentSigningView } from './documents/DocumentSigningView';
import { OnboardingLayout } from './layout/OnboardingLayout';
import { Onboarding } from './Onboarding';
import { OnboardingChecks } from './onboardingChecks/OnboardingChecks';
import { ErrorBoundary } from '../../../errorBoundary/ErrorBoundary';
import FallbackErrorModal from '../../modals/fallbackErrorModal/FallbackErrorModal';
import { useNavVisibility } from '../../navigation/useNavVisibility';
import MainContentPending from '../../pageStructure/mainContentPending';
import { ONBOARDING_PATHS, ONBOARDING_BASE_URL } from '../constants';
import { AddPaymentMethod } from './addPaymentMethod/AddPaymentMethod';

export const OnboardingRoutes = () => {
    const { setShowNav } = useNavVisibility();

    useEffect(() => {
        // Hide nav when this route is active
        setShowNav(false);

        // On unmount, put it back
        return () => setShowNav(true);
    }, [setShowNav]);

    return (
        <OnboardingLayout>
            <ErrorBoundary fallback={() => <FallbackErrorModal />}>
                <Suspense fallback={<MainContentPending />}>
                    <Switch>
                        <Route exact path={ONBOARDING_BASE_URL}>
                            <Onboarding />
                        </Route>
                        <Route exact path={ONBOARDING_PATHS.ONBOARDING_CHECKS}>
                            <OnboardingChecks />
                        </Route>
                        <Route
                            exact
                            path={ONBOARDING_PATHS.ONBOARDING_PAYMENT_METHOD}
                        >
                            <AddPaymentMethod />
                        </Route>
                        <Route path={ONBOARDING_PATHS.ONBOARDING_DOCUMENTS}>
                            <DocumentSigningView />
                        </Route>
                    </Switch>
                </Suspense>
            </ErrorBoundary>
        </OnboardingLayout>
    );
};
